import React, { useEffect } from "react";
import LazyLoad from "react-lazyload";
import { connect } from "react-redux";

import * as abMeActions from "../../../store/actions/aboutMe";

import Image from "../../atoms/Image/Image";
import Spinner from "../../atoms/Spinner/Spinner";
import Typography from "../../atoms/Typography/Typography";
import withErrorModal from "../../hoc/withErrorModal";

import "./About.scss";

const About = ({ summary, profileImage, loading, onFetchAboutMe }) => {
  useEffect(() => {
    onFetchAboutMe();
  }, [onFetchAboutMe]);

  if (loading) {
    return <Spinner />;
  }

  return (
    <LazyLoad height={500} offset={500}>
      <div className="about">
        <div>
          {summary &&
            summary.length > 0 &&
            summary.map((paragraph, index) => (
              <Typography key={index}>{paragraph.value}</Typography>
            ))}
        </div>
        <Image src={profileImage} alt="RoundedImg" width="250" height="250" />
      </div>
    </LazyLoad>
  );
};

const mapStateToProps = (state) => ({
  summary: state.aboutMeRed.summary,
  profileImage: state.aboutMeRed.profileImage,
  loading: state.aboutMeRed.loading,
});

const mapDispatchToProps = (dispatch) => ({
  onFetchAboutMe: () => dispatch(abMeActions.fetchAboutMe()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorModal(About));
